import setPendingCR from "./setPendingCR";
import setBlankCR from "./setBlankCR";
import store from "../store/index";
//-----------------------------------
// load specific combatant reactions
//-----------------------------------
export default function loadSpecificCombatantReactions(round, reactions, idx) {
  // console.log("---------------------------------");
  // console.log("loadSpecificCombatantReactions");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  let maxCR = this_store.config.max_cr;
  //----------
  // set vars
  //----------
  let slots_taken = 0;
  let to_slot = 0;
  //-------------
  // id combatant
  //-------------
  let id = combatants[idx].id;
  //------------------------------------
  // isolate reactions for specific round
  //------------------------------------
  let round_reactions = reactions.filter((a) => a.round == round);
  //--------------------------------------------
  // set to_set where reactions for round exist
  //--------------------------------------------
  if (round_reactions.length > 0) {
    slots_taken = round_reactions[0].reaction_count;
    to_slot = combatants[idx].cr - slots_taken + 1;
    //-------------------
    // else to_slot = cr
    //-------------------
  } else {
    to_slot = combatants[idx].cr;
  }
  // console.log("slots_taken = " + slots_taken)
  // console.log("cr = " + combatants[idx].cr)
  // console.log("to_slot = " + to_slot)
  //----------------------
  // loop possible max cr
  //----------------------
  for (let k = 1; k <= maxCR; k++) {
    //--------------------------
    // get action for cr number
    //--------------------------
    const match_reaction_idx = round_reactions.findIndex(function (a) {
      return a.number === k;
    });
    //------------------
    // set var cr props
    //------------------
    let cr = "cr" + k;
    let cr_name = "cr_name" + k;
    let cr_slug = "cr_slug" + k;
    //-----------------------------
    // where got reaction for slot
    //-----------------------------
    if (match_reaction_idx != -1) {
      combatants[idx][cr] = round_reactions[match_reaction_idx].reaction_image;
      combatants[idx][cr_name] =
        round_reactions[match_reaction_idx].reaction_name;
      combatants[idx][cr_slug] = round_reactions[match_reaction_idx].slug;
      //----------------------------
      // where no reaction for slot
      //----------------------------
    } else {
      //---------------
      // set slot parm
      //---------------
      let slot_parm = {
        id: id,
        cr_num: k,
      };
      if (k <= to_slot) {
        setPendingCR(slot_parm);
      } else {
        setBlankCR(slot_parm);
      }
    }
  }
  //--------------------------------------------------------------------
  // store reaction count for round where exists (take 1st as repeated)
  //--------------------------------------------------------------------
  if (round_reactions.length > 0) {
    combatants[idx].reaction_count = round_reactions[0].reaction_count;
  } else {
    combatants[idx].reaction_count = 0;
  }
}
